import React from 'react';
import PropTypes from 'prop-types';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Popover from 'infrastructure/js/components/popover/Popover/popover';
import { NotificationsStatuses } from '../../../enums/notificationsStatuses';
import * as NotificationHelper from '../../../utils/notificationHelper';

require('./NotificationsItem.scss');

export default class NotificationsItem extends React.PureComponent{

  constructor (props){
    super(props);

    this.labels = createLabelHelper('mat.wizards.notification.');

    this.state = {hoverStatus: null};
  }

  // componentWillMount () { //moved to constructor
  //   this.setState({hoverStatus: null});
  // }

  getPopoverComponent = (value) => {
    return <div>{value}</div>;
  };

  getPopOverMessage = (status) => {
    let message = '';
    switch (status) {
      case NotificationsStatuses.UNREAD:
        message = this.labels.get('mark.as.read.title');
        break;
      case NotificationsStatuses.READ:
        message = this.labels.get('mark.as.unread.title');
        break;
      default:
        console.error('NotificationsItemPopOverMessage - wrong status value: ' + status);
    }

    return message;
  }

  getIconPopOver(data) {

    if(!data) {
      return;
    }

    // In case that the row is hovered , use the status from the hoverStatus (seated by the setStatusOnHover function).
    let status = this.state.hoverStatus ? this.state.hoverStatus : this.props.item.status;

    let icon = this.getIcon(status);
    let message = this.getPopOverMessage(data.status);
    let isDisabled = data.disabled === true ? 'disabled' : '';

    return (<Popover
      popoverId='notification-item-popover'
      className='notifications-item-popover'
      popoverTitle={''}
      popoverComponent={this.getPopoverComponent(message)}
    >
      <label onClick={this.handelIconClick.bind(this)} className={`${icon} ${isDisabled}`}></label>
    </Popover>);
  }

  getIcon = (status) => {
    let icon = '';
    switch (status) {
      case NotificationsStatuses.UNREAD:
        icon = 'pl status-icon pl-notification-new-dot unread';
        break;
      case NotificationsStatuses.READ:
        icon = '';
        break;
      case NotificationsStatuses.UNREAD_HOVER:
        icon = 'pl pl-notification-radio-selected';
        break;
      case NotificationsStatuses.READ_HOVER:
        icon = 'pl pl-notification-radio-button';
        break;
      default:
        console.error('NotificationsItemStatusCell - wrong status value: ' + status);
    }

    return icon;
  }

  renderIconCell = () => {
    return (
      <div className='popup-icon-cell'>
        {this.getIconPopOver(this.props.item)}
      </div>
    );
  }

  renderContentCell = () => {
    return (
      <div className='popup-content-cell'>
        {NotificationHelper.BuildNotification(this.props.item.labelKey, this.props.item.paramsSet, this.props.item.category)}
      </div>
    );
  }

  renderTimeCell = () => {
    return (
      <div className='popup-time-cell'>
        <label>{this.props.item.m_Time}</label>
      </div>
    );
  }

  setStatusOnHover = (status) => {
    switch (status) {
      case NotificationsStatuses.UNREAD:
        this.setState({ hoverStatus: NotificationsStatuses.UNREAD_HOVER});
        break;
      case NotificationsStatuses.READ:
        this.setState({ hoverStatus: NotificationsStatuses.READ_HOVER});
        break;
      default:
        console.error('NotificationsItemSetStatusOnHover - wrong status value: ' + status);
    }
  }

  // Change the local state according to the item state on hover.
  // This state change displays an icon that represents the action that can be performed on hover according to status.
  handelOnMouseHover = () => {
    this.setStatusOnHover(this.props.item.status);
  }

  // Change the local state to the item's original status on leave.
  handelOnMouseLeave = () => {
    this.setState({ hoverStatus: null});
  }

  handelIconClick = () => {
    let data = {
      id: this.props.item.id
    };

    switch (this.state.hoverStatus) {
      case NotificationsStatuses.UNREAD_HOVER:
        data.status = NotificationsStatuses.READ;
        break;
      case NotificationsStatuses.READ_HOVER:
        data.status = NotificationsStatuses.UNREAD;
        break;
      default:
        console.error('NotificationsItemHandelIconClick - wrong status value: ' + status);
    }

    this.props.actions.changeReadStatus(data);
}


  renderItem = () => {
    return <div onMouseOver={this.handelOnMouseHover} onMouseLeave={this.handelOnMouseLeave} className='popup-notifications-item' >
      <div className='popup-notifications-row'>
        {this.renderIconCell()}
        {this.renderContentCell()}
        {this.renderTimeCell()}
      </div>
   </div>;
  }

  render() {
    return this.renderItem();
  }
}

NotificationsItem.propTypes = {
  item:  PropTypes.object,
  index: PropTypes.number
};
